import styled from 'styled-components';
import {Label} from '../../atoms/Label/index';

export default {
	Wrapper : styled.div`
		height:100%;
		background-color : white;
        padding : 2rem;
	`,
	Label : styled(Label)`
        font-size : 2rem;
    `,
	P : styled.p`
        padding-left : 1rem;
    `
};